// extracted by mini-css-extract-plugin
export default {"component":"customerTargetRoot__component___Dw9JS"};